import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannel } from "../schemas/schemas_0";
export { $Command };
export class DescribeChannelCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "DescribeChannel", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelCommand")
    .sc(DescribeChannel)
    .build() {
}
